import React, { useState, useEffect } from 'react';
import Cell from './Cell';

function Grid({ equipmentToTrail, slots, timeSlots, onChange }) {
  const [headerHours, setHeaderHours] = useState([]);

  const calculatePositionOnGrid = (slot) => {
    const firstSlot = timeSlots[0];
    const lastSlot = timeSlots[timeSlots.length - 1];
    const beforeOffset = firstSlot.startTimeMinutes;

    const minutesEnd = lastSlot.endTimeMinutes - beforeOffset;
    const minutesDuringDay = minutesEnd;

    const orderMinutesStart = slot.startTimeMinutes - beforeOffset;
    const orderMinutesEnd = slot.endTimeMinutes - beforeOffset;

    // zmiana z minut na procenty
    const leftPercent = (orderMinutesStart * 100) / minutesDuringDay
    const rightPercent = (orderMinutesEnd * 100) / minutesDuringDay

    const row = window.document.querySelector('.og-row');
    if (!row) return {}
    
    // zmiana z procentow na pixele
    const totalWidth = row.offsetWidth;
    const leftPixels = Math.round(leftPercent / 100 * totalWidth);
    const rightPixels = Math.round(rightPercent / 100 * totalWidth);

    return {
      left: leftPixels,
      right: rightPixels,
      width: rightPixels - leftPixels,
    }
  }

  const createHeaders = () => {
    const headers = timeSlots.map(x => ({
      ...x,
      position: calculatePositionOnGrid(x)
    }));
    setHeaderHours(headers)
  }

  useEffect(() => {
    createHeaders()
    window.addEventListener('resize', createHeaders);
  }, [timeSlots]);

  return (
    <>
      <p>{equipmentToTrail.equipment.title}</p>
   
      <div className="og-container">
        {/* head */}
        <div className="og-head">
          {headerHours.map(cell => {
            const date = new Date(cell.startTime)
            return <div key={cell.startTimeMinutes} className="og-head__hour" style={{ ...cell.position }}>
              <span className="hour">{date.getHours()}</span>
              <span className="minutes">{date.getMinutes() > 0 ? date.getMinutes() : '00'}</span>
            </div>
          })}
        </div>
        {/* grid */}
        <div className="og-grid">
          
          {slots.map(slot => (
            <div key={slot.index} className="og-row">
              <div className="og-row__number">{slot.index}</div>
              <div style={{ position: 'relative', width: '100%' }}>
                {slot.orders.map(order => 
                  <Cell 
                    key={order.uuid} 
                    order={order.orderData} 
                    position={order.position} 
                    onChange={onChange}
                  />)}
              </div>
            </div>
          ))}

        </div>
      </div>
    </>
  );
}

export default Grid;